// src/components/platform/ShowcaseCard.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { renderIcon } from '@dopomogai/utils';
import { Badge, IconName } from '@dopomogai/ui';

interface ShowcaseCardProps {
  icon: IconName;
  title: string;
  description: string;
  status: 'MVP' | 'POC' | 'Live';
  index: number;
}

const statusConfig = {
    MVP: { text: "MVP", color: "blue" as const },
    POC: { text: "PoC", color: "purple" as const },
    Live: { text: "Live", color: "green" as const },
}

export const ShowcaseCard: React.FC<ShowcaseCardProps> = ({ icon, title, description, status, index }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.5, delay: index * 0.1, ease: 'easeOut' } 
    },
  };
  
  const statusInfo = statusConfig[status];

  return (
    <motion.div
      variants={cardVariants}
      className="bg-white p-6 rounded-xl border-2 border-black h-full flex flex-col shadow-lg"
    >
      <div className="flex justify-between items-start mb-4">
        <div className="p-3 bg-slate-100 border-2 border-black rounded-lg">
          {renderIcon(icon, { size: 28 })}
        </div>
        <Badge text={statusInfo.text} accentColor={statusInfo.color} />
      </div>
      <h3 className="text-xl font-bold text-gray-900">{title}</h3>
      <p className="mt-2 text-slate-600 flex-grow">{description}</p>
    </motion.div>
  );
};